export const STEPS = [
  { id: "start", title: "Welcome", num: 0 },
  { id: "business", title: "Your Business", num: 1 },
  { id: "project", title: "Project Type", num: 2 },
  { id: "goals", title: "Goals & Needs", num: 3 },
  { id: "details", title: "Project Details", num: 4 },
  { id: "design", title: "Design & Brand", num: 5 },
  { id: "features", title: "Features", num: 6 },
  { id: "timeline", title: "Timeline", num: 7 },
  { id: "files", title: "Upload Files", num: 8 },
  { id: "review", title: "Review & Book", num: 9 },
];

export const PROJECT_TYPES = [
  { id: "website", label: "Website / Landing Page", icon: "globe", desc: "Corporate site, landing page, or web presence" },
  { id: "booking", label: "Booking System", icon: "calendar", desc: "Scheduling, appointments, reservations" },
  { id: "crm", label: "CRM System", icon: "users", desc: "Customer management, sales pipeline" },
  { id: "admin", label: "Admin / Portal System", icon: "shield", desc: "Internal tools, dashboards, user management" },
  { id: "calculator", label: "Calculator / Quote Tool", icon: "calculator", desc: "Pricing calculator, proposal generator" },
  { id: "ecommerce", label: "E-commerce", icon: "shopping-bag", desc: "Online store, product catalog" },
  { id: "automation", label: "Automation / Integration", icon: "zap", desc: "Workflow automation, API integrations" },
  { id: "custom", label: "Custom Solution", icon: "code", desc: "Something unique, tell us about it" },
];

export const INDUSTRIES = [
  "Technology", "Healthcare", "Finance", "Real Estate", "Construction",
  "Consulting", "Logistics", "Manufacturing", "Education", "Retail",
  "Hospitality", "Legal", "Media", "Non-profit", "Other",
];

export const COMPANY_SIZES = [
  "1-5 employees", "6-20 employees", "21-50 employees",
  "51-200 employees", "200+ employees",
];

export const BUDGETS = [
  "Not sure yet", "< 50,000 SEK", "50,000 - 150,000 SEK",
  "150,000 - 500,000 SEK", "500,000+ SEK",
];

export const TIMELINES = [
  "As soon as possible", "1-2 months", "3-6 months",
  "6-12 months", "No rush, planning ahead",
];

export const DESIGN_STYLES = [
  "Minimalist & Clean", "Bold & Colorful", "Corporate & Professional",
  "Dark & Techy", "Playful & Friendly", "Luxury & Premium", "No preference",
];

export const DYNAMIC_QUESTIONS = {
  website: [
    { key: "website_pages", type: "textarea", label: "What pages do you need?", placeholder: "e.g. Home, About, Services, Contact, Blog..." },
    { key: "website_audience", type: "text", label: "Who is your target audience?", placeholder: "e.g. B2B decision makers in Sweden" },
    { key: "website_content", type: "select", label: "Do you have content ready?", options: ["Yes, all ready", "Partially", "No, we need help with content"] },
    { key: "website_references", type: "textarea", label: "Any reference websites you like?", placeholder: "URLs or descriptions of sites you admire" },
  ],
  booking: [
    { key: "booking_what", type: "text", label: "What will be booked?", placeholder: "e.g. consultations, demo sessions, rooms..." },
    { key: "booking_volume", type: "text", label: "Expected booking volume?", placeholder: "e.g. 50 bookings/month" },
    { key: "booking_calendar", type: "select", label: "Calendar integration needed?", options: ["Google Calendar", "Outlook", "Both", "Other", "Not sure"] },
    { key: "booking_payments", type: "select", label: "Payments at booking?", options: ["Yes", "No", "Maybe later"] },
  ],
  crm: [
    { key: "crm_users", type: "text", label: "How many users will use the CRM?", placeholder: "e.g. 5-10 users" },
    { key: "crm_data", type: "textarea", label: "What data do you need to track?", placeholder: "e.g. contacts, deals, activities, documents..." },
    { key: "crm_current", type: "text", label: "Current CRM or tool?", placeholder: "e.g. Excel, HubSpot, none" },
    { key: "crm_integrations", type: "textarea", label: "Systems to integrate with?", placeholder: "e.g. email, accounting, ERP..." },
  ],
  admin: [
    { key: "admin_processes", type: "textarea", label: "What processes should the system handle?", placeholder: "e.g. user management, reporting, approvals..." },
    { key: "admin_roles", type: "text", label: "What user roles are needed?", placeholder: "e.g. admin, manager, viewer" },
    { key: "admin_data", type: "textarea", label: "What data will be managed?", placeholder: "e.g. customers, orders, inventory, documents..." },
  ],
  calculator: [
    { key: "calc_what", type: "textarea", label: "What should be calculated?", placeholder: "e.g. project cost, ROI, material quantities..." },
    { key: "calc_inputs", type: "textarea", label: "What inputs does the user provide?", placeholder: "e.g. area size, number of users, hours..." },
    { key: "calc_output", type: "select", label: "What's the output?", options: ["Price/quote", "PDF report", "Email proposal", "Dashboard", "Other"] },
  ],
  ecommerce: [
    { key: "ecom_products", type: "text", label: "How many products?", placeholder: "e.g. 50-200 products" },
    { key: "ecom_payments", type: "select", label: "Payment methods?", options: ["Card (Stripe)", "Invoice", "Swish", "Multiple", "Not sure"] },
    { key: "ecom_shipping", type: "select", label: "Physical or digital products?", options: ["Physical (shipping needed)", "Digital (downloads)", "Both", "Services"] },
  ],
  automation: [
    { key: "auto_processes", type: "textarea", label: "What processes should be automated?", placeholder: "e.g. lead follow-up, invoice generation, data sync..." },
    { key: "auto_systems", type: "textarea", label: "What systems need to be connected?", placeholder: "e.g. CRM, email, accounting, ERP..." },
    { key: "auto_triggers", type: "textarea", label: "What triggers the automation?", placeholder: "e.g. new form submission, time-based, status change..." },
  ],
  custom: [
    { key: "custom_description", type: "textarea", label: "Describe your idea", placeholder: "Tell us about the solution you need..." },
    { key: "custom_users", type: "text", label: "Who will use this system?", placeholder: "e.g. internal team, customers, both" },
    { key: "custom_similar", type: "textarea", label: "Any similar products or references?", placeholder: "Tools or systems that do something similar" },
  ],
};
